import React from "react";

function PrintIcon2() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
    >
      <g clip-path="url(#clip0_2391_13175)">
        <path
          d="M4.21875 0C3.11562 0 2.21875 0.896875 2.21875 2V5H4.21875V2H11.3031L12.2188 2.91563V5H14.2188V2.91563C14.2188 2.38438 14.0094 1.875 13.6344 1.5L12.7188 0.584375C12.3438 0.209375 11.8344 0 11.3031 0H4.21875ZM12.2188 11V12V14H4.21875V12V11.5V11H12.2188ZM14.2188 12H15.2188C15.7719 12 16.2188 11.5531 16.2188 11V8C16.2188 6.89687 15.3219 6 14.2188 6H2.21875C1.11563 6 0.21875 6.89687 0.21875 8V11C0.21875 11.5531 0.665625 12 1.21875 12H2.21875V14C2.21875 15.1031 3.11562 16 4.21875 16H12.2188C13.3219 16 14.2188 15.1031 14.2188 14V12ZM13.7188 7.75C13.9177 7.75 14.1084 7.82902 14.2491 7.96967C14.3897 8.11032 14.4688 8.30109 14.4688 8.5C14.4688 8.69891 14.3897 8.88968 14.2491 9.03033C14.1084 9.17098 13.9177 9.25 13.7188 9.25C13.5198 9.25 13.3291 9.17098 13.1884 9.03033C13.0478 8.88968 12.9688 8.69891 12.9688 8.5C12.9688 8.30109 13.0478 8.11032 13.1884 7.96967C13.3291 7.82902 13.5198 7.75 13.7188 7.75Z"
          fill="#277DFE"
        />
        <path
          d="M4.21875 0C3.11562 0 2.21875 0.896875 2.21875 2V5H4.21875V2H11.3031L12.2188 2.91563V5H14.2188V2.91563C14.2188 2.38438 14.0094 1.875 13.6344 1.5L12.7188 0.584375C12.3438 0.209375 11.8344 0 11.3031 0H4.21875ZM12.2188 11V12V14H4.21875V12V11.5V11H12.2188ZM14.2188 12H15.2188C15.7719 12 16.2188 11.5531 16.2188 11V8C16.2188 6.89687 15.3219 6 14.2188 6H2.21875C1.11563 6 0.21875 6.89687 0.21875 8V11C0.21875 11.5531 0.665625 12 1.21875 12H2.21875V14C2.21875 15.1031 3.11562 16 4.21875 16H12.2188C13.3219 16 14.2188 15.1031 14.2188 14V12ZM13.7188 7.75C13.9177 7.75 14.1084 7.82902 14.2491 7.96967C14.3897 8.11032 14.4688 8.30109 14.4688 8.5C14.4688 8.69891 14.3897 8.88968 14.2491 9.03033C14.1084 9.17098 13.9177 9.25 13.7188 9.25C13.5198 9.25 13.3291 9.17098 13.1884 9.03033C13.0478 8.88968 12.9688 8.69891 12.9688 8.5C12.9688 8.30109 13.0478 8.11032 13.1884 7.96967C13.3291 7.82902 13.5198 7.75 13.7188 7.75Z"
          fill="#277DFE"
        />
      </g>
      <defs>
        <clipPath id="clip0_2391_13175">
          <path d="M0.21875 0H16.2188V16H0.21875V0Z" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default PrintIcon2;
